"use strict";

jQuery( function ($) {
    
    /* If awc is present set the cookie with an ajax call */
    if ($('#hap-awc').length) {
        var awc_code = $('#hap-awc').data('awc');
        
        if (awc_code) {
            $.ajax({
                url      : themevars.ajaxurl,
                data     : {
                    action : 'set_awin_cookie',
                    awc: awc_code,
                },
                type     : 'POST',
                dataType : 'json'
            });
        }
    }
});